import React, { Component } from 'react'
import PropTypes from 'prop-types'
import injectSheet from 'react-jss'
import classNames from 'classnames'
import { connect } from 'react-redux'
import backgroundImage from '../../assets/images/common/background.png'
import { getTheme } from '../../reducers/theme'

const styles = {
  wrapperOverlay: {
    position: 'fixed',
    top: 'calc(20vh - 2vh)',
    left: 0,
    right: 0,
    bottom: 0,
    padding: 0,
    margin: 0,
    height: 'calc(83vh + 2vh)',
  },
  wrapper: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1000,
  },
  backdrop: {
    width: '100%',
    height: '100%',
    backgroundColor: 'black',
    opacity: 0.4,
  },
  background: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0.15,
    borderRadius: '10px 10px 0 0',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundImage: `url(${backgroundImage})`,
  },
  container: {
    position: 'absolute',
    left: '15%',
    right: '15%',
    top: '20%',
    width: '70%',
    borderRadius: '10px',
  },
  content: {
    paddingLeft: '35px',
    paddingRight: '35px',
    paddingBottom: '10px',
    maxHeight: '60vh',
    background: 'white',
    borderRadius: '0 0 10px 10px',
    color: 'grey',
  },
  contentWithIcon: {
    paddingTop: '100px',
  },
  navBar: {
    position: 'relative',
    borderRadius: '10px 10px 0 0',
  },
  navBarTitle: {
    padding: '16px',
    fontSize: '20px',
    color: 'white',
    textAlign: 'center',
    fontWeight: 600,
  },
  iconContainer: {
    justifyContent: 'center',
    display: 'flex',
    position: 'absolute',
    left: 0,
    right: 0,
    top: '50px',
  },
  icon: {
    height: '100px',
  },
}

const mapStateToProps = (state) => {
  return {
    theme: getTheme(state),
  }
}

@connect(mapStateToProps)
@injectSheet(styles)
class PopupModal extends Component {
  handleBackDropClick = () => {
    const { onDismiss } = this.props
    if (onDismiss) {
      onDismiss()
    }
  }

  render() {
    const {
      children, classes, title, icon, theme,
    } = this.props
    return (
      <div className={classes.wrapper}>
        <div className={classes.backdrop} onClick={this.handleBackDropClick} />
        <div className={classes.container}>
          <div
            className={classes.navBar}
            style={{
              background: `linear-gradient(-90deg, ${theme.gradient_color_1}, ${
                theme.gradient_color_2
              })`,
            }}
          >
            <div className={classes.navBarTitle}>{title}</div>
            <div className={classes.background} />
          </div>
          {icon && (
            <div className={classes.iconContainer}>
              <img className={classes.icon} src={icon} alt="" />
            </div>
          )}
          <div
            className={classNames(classes.content, {
              [classes.contentWithIcon]: !!icon,
            })}
          >
            {children && children}
          </div>
        </div>
      </div>
    )
  }
}

PopupModal.propTypes = {
  title: PropTypes.string.isRequired,
  theme: PropTypes.object,
  icon: PropTypes.string,
  overlay: PropTypes.bool,
  children: PropTypes.node,
  classes: PropTypes.object,
  onDismiss: PropTypes.func,
}

export default PopupModal
